<script lang="ts">
import { defineComponent, type PropType } from 'vue';
import RowStakeNumber from '@/components/calculator/item/row-stake-number.vue';
import RowStakeAmount from '@/components/calculator/item/row-stake-amount.vue';
import RowPossibleMultipleOutcome from '@/components/calculator/item/row-possible-multiple-outcome.vue';
import RowActualMultipleOutcome from '@/components/calculator/item/row-actual-multiple-outcome.vue';
import RowOutcome from '@/components/calculator/item/row-outcome.vue';
// import RowsBet from '@/components/calculator/item/rows-bet.vue';
import RowBet from '@/components/calculator/item/row-bet.vue';
import RowPossibleCashout from '@/components/calculator/item/row-possible-cashout.vue';
import type { BetSlipSelection, Stake } from '@/types/coupons';

export default defineComponent({
  name: 'multiple',
  components: {
    RowPossibleCashout,
    RowBet,
    RowOutcome,
    RowPossibleMultipleOutcome,
    RowActualMultipleOutcome,
    RowStakeAmount,
    RowStakeNumber,
  },
  props: {
    stake: {
      type: Object as PropType<Stake>,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    betSlipSelections: {
      type: Array as PropType<BetSlipSelection[]>,
      required: true,
    },
  },
});
</script>

<template>
  <section class="grid grid-cols-[10fr_23fr_17fr] gap-y-2">
    <row-stake-number :stake="stake" :index="index" />
    <row-stake-amount :stake="stake" />
  </section>

  <section class="mx-4">
    <table class="basic-table__unaligned w-full resize-text">
      <tbody>
        <row-bet
          v-for="bet in stake.bets"
          :bet="bet"
          :betSlipSelection="betSlipSelections.find((s) => s.selectionId === bet.selection.Id)!"
        />
      </tbody>
    </table>
  </section>

  <section class="grid grid-cols-[max-content_20fr_17fr] gap-y-2">
    <row-possible-multiple-outcome :stake="stake" />
    <row-actual-multiple-outcome :stake="stake" />
    <row-possible-cashout :stake="stake" v-if="!stake.status"/>
    <row-outcome :stake="stake" />
  </section>
</template>

<style lang="scss">
table.resize-text {
  & td,
  th {
    @apply text-base align-text-top pb-4;
  }
}
</style>
